import * as process from 'process';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

global.process = process;
global.Buffer = [];

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);